import Operation from "../index.js";

export default {
    //获取校区logo和name
    findSchoolNameAndLogo(id, fn) {
        Operation.Http.post(`/wx/findSchoolNameAndLogo?id=${id}`, null, fn)
    },
    //获取签名
    shareSignature(params, fn) {
        Operation.Http.post(`/wx/shareSignature`, params, fn)
    },
    //获取学生信息
    getStudentInfoById(id, fn) {
        Operation.Http.post(`/wx/getStudentInfoById?studentId=${id}`, null, fn)
    }
}


// WEBPACK FOOTER //
// ./src/request/api/wx.js